<template>
    <div>
        <div style="background-color: rgba(0, 0, 0, 0.2); position:fixed; z-index:1; left:0px; top:0px; width:100%; height:calc(100%);" v-if="isShowDateSelector" @click="hide"></div>
        <div style="position:fixed;  z-index:10;left:0px;bottom:0px;  width:100%; background-color: white; padding:15px;transition: transform 0.3s; transform:translateY(0%)" :style="{transform : isShowDateSelector ? 'translateY(0%)' : 'translateY(calc(100%))'}">
            <div style="display:flex; position: relative;" v-if="reloadFlag">
                <div style="flex:1;"></div>
                <div style="z-index: 0; width: 100%; height: 25px; border-radius: 5px; background-color: #ffe9db; position: absolute; top: 50%; transform: translateY(-50%);"></div>
                <ScrollSelector :list="years" style="height:200px;width:100px; overflow:hidden;" :init-value="initYear" :detect-value-change="detectYearChange"></ScrollSelector>
                <ScrollSelector :list="months" style="height:200px;width:70px; overflow:hidden;" :init-value='initMonth' :detect-value-change="detectMonthChange"></ScrollSelector>
                <ScrollSelector :list="days" style="height:200px;width:70px; overflow:hidden;" :init-value="initDay" :detect-value-change="detectDayChange"></ScrollSelector>
                <!-- <div style="display: flex; align-items: center; position: relative; font-size: 15px; font-weight: 500; color: #606060; line-height: 30px;">{{dayOfWeeks}}요일</div> -->
                <div style="flex:1;"></div>
            </div>
            <div style="display:flex; margin-top:20px;">
                <div style="flex:1;"></div>
                <div style="display:flex;">
                    <template v-if="isShowDiscuss">
                        <div @click="discuss">협의</div>
                        <div style="width:10px;"></div>
                    </template>
                    <div style="display: flex; gap: 10px; font-size: 16px; font-weight: 500;">
                        <div @click="hide">취소</div>
                        <div @click="confirm" >확인</div>
                    </div>
                </div>
            </div>
            <div :style="{height : $GlobalStore.navigationBarHeight() + 'px'}"></div>
        </div>
    </div>
</template>

<script>

    import ScrollSelector from "./ScrollSelector";
    import moment from 'moment';
    export default {
        name: "DateSelectorPopupVer2",
        components: {ScrollSelector},
        props : {
            hide : {
                type : Function,
                default : () => {}
            },
            isShowDateSelector : {
                type : Boolean,
                default : false
            },
            startDate : {
                type : String,
                default : '',
            },
            completeAction : {
                type : Function,
                default : () => {},
            },
            isShowDiscuss : {
                type : Boolean,
                default : () => {}
            }

        },
        watch : {
            isShowDateSelector(){
                if(this.isShowDateSelector){
                    if(this.startDate === '협의'){
                        this.startDate = moment().format('YYYY-MM-DD');
                    }
                    this.reloadFlag = true;
                    this.refresh();
                }else {
                    setTimeout(() => {
                        this.reloadFlag = false;
                    }, 300);
                }
            },
        },
        data(){
            return {
                years : [],
                months : [],
                days : [],
                weeks : ["일", "월", "화", "수", "목", "금", "토"],
                initYear : '',
                initMonth : '',
                initDay : '',
                selectedYear : '',
                selectedMonth : '',
                selectedDay : '',
                reloadFlag : false,
                dayOfWeeks : '',
                date : ''
            }
        },
        methods : {
            setDays(year, month){
                const monthFirstDay = moment(year + '-' + month + '-01', 'YYYY-MM-DD');
                const monthLastDay = moment(year + '-' + month + '-01', 'YYYY-MM-DD').endOf('month');

                const startDay = parseInt(monthFirstDay.format('DD'));
                const endDay = parseInt(monthLastDay.format('DD'));

                const days = [];
                for(let i = startDay; i <= endDay; i++){
                    let dayStr = i + '';
                    if(dayStr < 10) dayStr = '0' + i;
                    days.push({label : dayStr + '일', value : dayStr});
                }

                this.days = days;
            },
            confirm(){
                this.completeAction(this.selectedYear + '-' + this.selectedMonth + '-' + this.selectedDay, this.dayOfWeeks);
                this.hide();
            },
            discuss(){
                this.completeAction('협의');
                this.hide();
            },
            refresh(){
                // const curMoment = moment();
                const startYear = 1900
                // const endYear = 2024
                const endYear = parseInt(moment().format('YYYY'));
                const years = [];
                for (let year = startYear; year <= endYear; year++) {
                    let curYear = moment(year, "YYYY").format("YYYY")
                    years.push({label : curYear + '년', value : curYear});
                }

                this.years = years;

                const months = [];
                for(let i = 1; i < 13; i++){
                    let monthStr = i + '';
                    if(i < 10) monthStr = '0' + i;
                    months.push({label : monthStr + '월', value : monthStr})
                }
                this.months = months;

                const today = moment();
                this.setDays(today.format('YYYY'), today.format('MM'));

                if(this.startDate){
                    this.initYear = this.startDate.substr(0, 4);
                    this.initMonth = this.startDate.substr(5, 2);
                    this.initDay = this.startDate.substr(8, 2);
                } else {
                    this.initYear = moment().format('YYYY');
                    this.initMonth = moment().format('MM');
                    this.initDay = moment().format('DD');
                }
                this.date = this.initYear + '-' + this.initMonth + '-' + this.initDay
                const fullDate = new Date(this.date)
                this.dayOfWeeks = this.weeks[fullDate.getDay()]
                
            },
            detectYearChange(selectedData){
                this.selectedYear = selectedData.value;
                this.getDayOfWeeks()
            },
            detectMonthChange(selectedData){
                this.selectedMonth = selectedData.value;
                this.getDayOfWeeks()
                this.setDays(this.selectedYear, selectedData.value);
                if(parseInt(this.selectedDay) > this.days.length){
                    this.initDay = this.days[this.days.length - 1].value;
                }
            },
            detectDayChange(selectedData){
                this.selectedDay = selectedData.value;
                this.initDay = selectedData.value;
                this.getDayOfWeeks()
            },
            getDayOfWeeks() {
                this.date = this.selectedYear + '-' + this.selectedMonth + '-' + this.selectedDay
                const fullDate = new Date(this.date)
                this.dayOfWeeks = this.weeks[fullDate.getDay()]
            }
        },
        created(){
            this.refresh();
        },
    }
</script>

<style scoped>
*{font-family:var(--global-font-family)}
</style>